import React from 'react'
import { connect } from 'react-redux'
import { compose, withState } from 'recompose'
import { FormattedMessage } from 'react-intl'

import Overlay from '../components/Overlay'
import Form from '../components/ContacsEngForm'

const ContactsPage = ({ data, fetching, formOpened, setFormState }) => (
  <div>
    <Overlay isActive={true} stillActive={true}>
      <Form />
    </Overlay>
  </div>
)

const mapStateToProps = state => ({
  ...state.contacts,
  currentLocale: state.intl.locale
})
export default compose(
  connect(mapStateToProps),
  withState('formOpened', 'setFormState', true)
)(ContactsPage)



// WEBPACK FOOTER //
// ./src/containers/EngContacts.jsx